var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDefaultCommunityIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#000",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 13.217c-2.75 0-4.978 2.31-4.978 5.158h9.956c0-2.849-2.228-5.158-4.978-5.158M19.642 13.217c1.1 0 1.992-1.155 1.992-2.579 0-1.424-.892-2.579-1.992-2.579s-1.991 1.155-1.991 2.58c0 1.423.891 2.578 1.991 2.578"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.543 13.862a4.16 4.16 0 0 0-1.892.452 5.676 5.676 0 0 1 1.722 4.061h4.212c.026-.18.04-.364.04-.55 0-2.189-1.827-3.963-4.082-3.963M8.457 13.862c-2.255 0-4.082 1.774-4.082 3.963 0 .186.014.37.04.55h4.212c0-1.582.658-3.017 1.722-4.061a4.16 4.16 0 0 0-1.892-.452M11.677 9.026c0 1.603 1.04 2.902 2.323 2.902s2.323-1.3 2.323-2.902S15.283 6.125 14 6.125s-2.323 1.299-2.323 2.901M8.026 8.06c-1.283 0-2.323 1.154-2.323 2.578s1.04 2.58 2.323 2.58 2.323-1.156 2.323-2.58c0-1.424-1.04-2.579-2.323-2.579"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDefaultCommunityIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/default-community-icon.d265941b.svg";
export { ForwardRef as ReactComponent };